import * as React from 'react';

import FromFile from '../../containers/ProposalCreator/FromFile';
import FromTemplate from '../../containers/ProposalCreator/FromTemplate';

interface ProposalCreatorProps {
	isDisplayed: boolean;
	isFromFile: boolean;
}

const ProposalCreator = ({ isDisplayed, isFromFile }: ProposalCreatorProps) => (
	<>
		<FromFile isDisplayed={isFromFile && isDisplayed} />
		<FromTemplate isDisplayed={!isFromFile && isDisplayed} />
	</>
);

export default ProposalCreator;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ProposalCreator/index.tsx